var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.template && _vm.record_types_by_name)?_c('BundledDBEditor',{attrs:{"object_function":"create","object_fq_name":"dns.record","modal_id":_vm.modal_id,"template":_vm.template,"presets":_vm.presets,"input_reducer":_vm.reducer,"prepend":true,"non_optionals_order":['fqdn', 'type', 'data', 'fqdn_description', 'fqdn_description_overwrite']}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }